
if(typeof window.ProductGallery == 'undefined') {
    class ProductGallery extends HTMLElement {
        constructor() {
            super();
            this.init()

            // Add resize to update container height
            let watting ;
            let _this = this;
            $(window).on('resize', function(){
                clearTimeout(watting);
                watting = setTimeout(function(){
                    this.update();
                }.bind(_this), 50)
            })

            // Bind event listeners
            this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
            this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
            this.prevThumbnailButton && this.prevThumbnailButton.addEventListener('click', this.onButtonClick.bind(this));
            this.nextThumbnailButton && this.nextThumbnailButton.addEventListener('click', this.onButtonClick.bind(this));
            // Listen for variant selection change to make current variant image active
            window.addEventListener('message', this.onVariantChange.bind(this))

            this.classList.add('initialized');
        }

        init() {
            // Set up our DOM element variables
            this.imagesContainer = this.querySelector('.product-gallery__images');
            this.thumbnails = this.initThumbnail();
            this.images = this.querySelectorAll('.product-gallery__image');
            this.prevButton = this.querySelector('.slider-button[name="previous"]');
            this.nextButton = this.querySelector('.slider-button[name="next"]');
            this.prevThumbnailButton = this.querySelector('.gallery-control__button[name="previous"]');
            this.nextThumbnailButton = this.querySelector('.gallery-control__button[name="next"]');
            let gallery_control = this.querySelector('.gallery-control');
            if(this.images.length <= 3) {
                gallery_control && (gallery_control.style.display = 'none');
            } else {
                gallery_control && (gallery_control.style.display = 'block');
            }
            if(this.images.length <= 1) {
                this.prevButton.style.display = "none";
                this.nextButton.style.display = "none";
            } else {
                this.prevButton.style.display = "block";
                this.nextButton.style.display = "block";
            }
            // If there is no active images set the first image to active
            if (this.findCurrentIndex() === -1) {
                this.setCurrentImage(this.images[0])
            }
            this.onNavItemDrag();
        }

        onVariantChange(event) {
            if (!event.data || event.data.type !== 'variant_changed') return
            const currentImage = Array.from(this.images).find(item => item.dataset.mediaId == event.data.variant.featured_media.id)
            if (currentImage) {
                this.setCurrentImage(currentImage)
            }
        }

        onNavItemDrag() {
            let thumbnails = $('.product-gallery__contain');
            thumbnails.find('img').on('dragstart', function(){ return false;});
            let clicked, clickY, clickX, current;
            const updateScrollPos = function (e) {
                thumbnails.scrollTop(current + (clickY - e.pageY));
            };
            let initEvent = {
                mousemove: function (e) {
                    clicked && updateScrollPos(e);
                },
                mousedown: function (e) {
                    if(!e.target.closest('.product-gallery__contain')) return;
                    clicked = true;
                    clickY = e.pageY;
                    clickX = e.pageX;
                    current = thumbnails.scrollTop();
                },
                mouseup: function (e) {
                    clicked = false;
                    // replace event click
                    if(Math.abs(clickY - e.pageY) < 10 && Math.abs(clickX - e.pageX) < 10) {
                        this.onNavItemClick(e);
                    }
                },
                change_media: function(e) {
                    this.onNavItemClick(e);
                }
            };

            for(let i in initEvent) {
                $('body').on(i, initEvent[i].bind(this));
            }
        }

        initThumbnail () {
            let _this = this;
            return {
                _this: _this,
                $navItems : $(this).find('.product-gallery__nav-item'),
                $wrapItem: $(this).find('.product-gallery__nav'),
                $contain: $(this).find('.product-gallery__contain'),
                getThumbActive: function(){
                    return this.$wrapItem.find('.product-gallery__nav-item.active');
                },
                getScrolltTop: function(){
                    return this.$contain.scrollTop();
                },
                getScrolltBottom: function(){
                    return this.$contain.scrollTop() + this.$contain.height();
                },
                exist: function() {
                    if($(_this).find('.product-gallery__nav').length == 0 || $(_this).find('.product-gallery__nav').is(":hidden")) {
                        return false;
                    }
                    return true;
                },
                scrollNav: function(top){

                    let current =  this.$contain.scrollTop();
                    let spacePerStep = (top - current);

                    let _this = this;
                    let time;
                    let lastTime;

                    if(window.jQuery) {
                        $(this.$contain).animate({scrollTop: top },'300');
                    } else {
                        this.run = function(t){
                            if(typeof time === 'undefined'){
                                lastTime = time = t;
                                requestAnimationFrame(_this.run);
                            } else {
                                current += spacePerStep / ( 300 / (t - lastTime) );
                                _this.$contain.scrollTop(current);
                                lastTime = t;
                                if(time + 300 >= t) {
                                    requestAnimationFrame(_this.run);
                                }
                            }
                        }
                        this.run();
                    }



                },
                stickBottom: function(position){

                },
                stickTop: function(position){

                },
                autoShowThumb: function(){
                    if(!this.exist()) return;

                    let $thumbActive = this.getThumbActive();
                    let scrollTop = this.$contain.scrollTop();
                    let containHeight = this.$contain.height();

                    let thumbTop = $thumbActive.position().top;
                    if(thumbTop < scrollTop) {
                        this.scrollNav(thumbTop);
                    } else if (thumbTop + $thumbActive.outerHeight() - containHeight > scrollTop) {
                        this.scrollNav(thumbTop + $thumbActive.outerHeight() - containHeight);
                    }
                }
            }
        }

        onNavItemClick(event) {
            if(!(event.target.closest('.product-gallery__nav-item') || event.type == "change_media")) return;
            let mediaId, imageActive;
            if(typeof event.detail.currentVariant == 'string') {
                mediaId = event.detail.currentVariant;
            } else {
                mediaId = event.target.closest('li').dataset.mediaId;
            }

            //this.images.forEach(item => item.classList.remove('product-gallery__image--active'))

            imageActive = Array.from(this.images).find(item => item.dataset.mediaId === mediaId);
            // set active first image when cannot find media ID
            if(!imageActive) {
                imageActive = this.images[0];
            }
            this.setCurrentImage(imageActive)
        }

        update() {
            if (window.innerWidth < 768) {
                let itemWidth = this.thumbnails.$navItems[0].offsetWidth;
                itemWidth += parseFloat(window.getComputedStyle(this.thumbnails.$navItems[0]).getPropertyValue('margin-right'));
                this.thumbnails.$wrapItem.css('width', (this.thumbnails.$navItems.length * itemWidth) + 'px');
                const galleryNav = document.querySelector('.product-gallery__nav');
                const galleryNavItem = document.querySelectorAll('.product-gallery__nav-item');
                const activeItemIndex = [...galleryNavItem].findIndex(item => item.classList.contains('active'));
                const activeItem = this.thumbnails.$navItems[activeItemIndex];
                const activeItemOffsetRight = activeItem.offsetLeft + itemWidth;
                if ((activeItemOffsetRight - Math.abs(parseFloat(this.getTranslateXValue(galleryNav)))) > window.innerWidth) {
                    const lastItem = this.thumbnails.$navItems[this.thumbnails.$navItems.length - 1];
                    const lastItemOffsetRight = lastItem.offsetLeft + itemWidth;
                    let translateX = -(itemWidth * activeItemIndex);
                    if ((lastItemOffsetRight - Math.abs(translateX)) < window.innerWidth) {
                        translateX += this.thumbnails.$contain[0].offsetWidth - (lastItemOffsetRight - Math.abs(translateX));
                    }
                    galleryNav.style.transform = `translateX(${translateX}px)`;
                } else if (activeItemOffsetRight < window.innerWidth) {
                    galleryNav.style.transform = `translateX(0px)`;
                }
            } else {
                this.thumbnails.$wrapItem.css('width', '80px');
                this.style.minHeight = this.imagesContainer.querySelector('.product__media img') ? `${this.imagesContainer.querySelector('.product__media img').offsetHeight}px` : '586px'
            }
        }

        getTranslateXValue(element) {
            const style = window.getComputedStyle(element);
            const transform = style.transform || style.webkitTransform || style.mozTransform;

            // If there's no transform or it's not a matrix, return 0
            if (!transform || transform === 'none') {
                return 0;
            }

            // Parse the transform matrix to get the translateX value
            const matrix = new DOMMatrixReadOnly(transform);
            return matrix.m41;
        }

        setCurrentImage(elem) {
            for(let element of this.thumbnails.$navItems) {
                const elemActive = document.querySelector(`.product-gallery__image[data-media-id="${elem.dataset.mediaId}"]`);

                element.classList.remove('active');
                if(elem.dataset.mediaId == element.dataset.mediaId) {
                    element.classList.add('active');
                    if (element == this.thumbnails.$navItems[0]) {
                        this.prevThumbnailButton.classList.add('disable');
                    } else {
                        this.prevThumbnailButton.classList.remove('disable');
                    }
                    if (element == this.thumbnails.$navItems[this.thumbnails.$navItems.length - 1]) {
                        this.nextThumbnailButton.classList.add('disable');
                    } else {
                        this.nextThumbnailButton.classList.remove('disable');
                    }
                }
                if(elem.dataset.mediaId == element.dataset.mediaId && !elemActive.classList.contains('product-gallery__image--active')) {
                    this.setMainImage(elem)
                }
            }

            this.update()
        }

        setMainImage(elem) {
            this.images.forEach(item => {
                item.classList.remove('product-gallery__image--active')
            })
            if(elem) {
                elem.classList.add('product-gallery__image--active')
                this.fadeIn(elem, 200)
                this.thumbnails.exist() && this.thumbnails.autoShowThumb();
            }

            this.update()
        }

        fadeIn(el, time, callback) {
            el.style.opacity = 0;

            var last = +new Date();
            var tick = function() {
              el.style.opacity = +el.style.opacity + (new Date() - last) / time;
              last = +new Date();

              if (+el.style.opacity < 1) {
                (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
              } else {
                el.style.opacity = "";
                typeof callback === "function" && callback();
              }
            };

            tick();
        }

        fadeOut(el, time, callback) {
            el.style.opacity = 1;

            var last = +new Date();
            var tick = function() {
              el.style.opacity = +el.style.opacity - (new Date() - last) / time;
              last = +new Date();

              if (+el.style.opacity > 0) {
                (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
              } else {
                el.style.opacity = "";
                typeof callback === "function" && callback();
              }
            };

            tick();
        }

        findCurrentIndex() {
            return Array.from(this.images).findIndex(item => item.classList.contains('product-gallery__image--active'))
        }

        onButtonClick(event) {
            event.preventDefault();
            let index = this.findCurrentIndex()
            if (event.currentTarget.name === 'next') {
                index++
            } else {
                index--
            }
            this.images[index] && this.setCurrentImage(this.images[index])
        }
    }

    customElements.define('product-gallery', ProductGallery);
}
